import config from 'Config';

// App version is semver: x.x.x
// Version Code is generated from app version to allow numeric comparisons
const VERSION_CODE: number =
  (parseInt(
    process.env.VERSION.split('.')
      .map((v) => v.padStart(2, '0'))
      .join(''),
    10
  ) || 0) + config.api.defaultAppVersion;
// On web, we send VERSION_CODE as build number, except for local builds
export const BUILD_NUMBER: number = config.sparks.isDebugBuild === true ? 10000 : VERSION_CODE;
